import './layout.css'

/**
 * 
 * @param {string} size values allowed: "small", "default", "large", "x-large", "xx-large"
 * @returns 
 */
export function HSpacer({size}) {

    return (
        <div className={`hspacer ${size}`}>
        </div>
    )
}